import React from 'react';

function HomeLayout({ header, footer, children }) {
  return (
    <div className='home-layout'>
      <div className='home-layout__header'>{header}</div>
      <div className='home-layout__content'>{children}</div>
      <div className='home-layout__footer'>{footer}</div>
    </div>
  );
}

export default HomeLayout;
